import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { catchError, of, tap } from 'rxjs';
import { ActivityResponse } from 'src/app/model/dto/ActivityResponse';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { ActivityService } from 'src/app/modules/agenda/services/activity-services';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { InviteMiniJpoDto } from '../mini-jpo-form/inviteMiniJpoDto.model';

@Component({
  selector: 'app-jpo-form',
  templateUrl: './jpo-form.component.html',
  styleUrls: ['./jpo-form.component.css'],
})
export class JpoFormComponent implements OnInit {
  showSpinner = true;
  alreadyConfirm: boolean = false;

  submitSuccess: boolean = false;
  activity!: ActivityResponse;
  jpoForm!: FormGroup;

  prenomCtrl!: FormControl;
  emailCtrl!: FormControl;
  nomCtrl!: FormControl;
  indicatifCtrl!: FormControl;

  genderCtrl!: FormControl;
  professionnalSituationCtrl!: FormControl;
  lieuDeProvenanceCtrl!: FormControl;
  waveNumberCtrl!: FormControl;
  lieuDeParticipationCtrl!: FormControl;

  regions!: any;
  lieuMiniJPO!: any;

  filled: boolean = false;
  erreur: boolean = false;
  date: Date = new Date();
  isLoading: boolean = true;
  session: boolean = false;
  noSession: boolean = false;
  activityId: number | undefined;
  infoResponse!: string;
  isSubmitting: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerServiceService,
    private service: ActivityService
  ) {}
  ngOnInit() {
    this.spinnerService.showSpinner();
    this.regions = LOCALISATIONS.Regions;
    this.lieuMiniJPO = ProfilDetails.Jpo2025;
    // console.log('Les lieu de JPO : ', this.lieuMiniJPO);
    this.initControls();
    this.initForm();
    this.getCurrentJpo();
  }

  onSubmitForm() {
    // console.log('Le formulaire : ', this.miniJpoForm.value);
    if (this.jpoForm.valid) {
      this.filled = false;
      this.isSubmitting = true;
      const formValue = this.jpoForm.value;
      // console.log('Le formulaire est valide : ', this.jpoForm.value);

      const dto: InviteMiniJpoDto = {
        firstName: formValue['prenom'],
        lastName: formValue['nom'],
        email: formValue['email'],
        gender: formValue['gender'],
        telephone: this.indicatifCtrl.value + formValue['telephone'],
        statusPro: formValue['professionnalSituation'],
        lieuProvenane: formValue['lieu'],
        lieuDeParticipationMINIJPO: formValue['lieuDeParticipation'],
      };

      // console.log('object : ', dto);
      if (this.activityId != undefined) {
        this.service
          .jpoSubmission(dto, this.activityId)
          .pipe(
            tap((response: CustomResponse) => {
              switch (response.status) {
                case 200:
                  this.jpoForm.reset();
                  this.submitSuccess = true;
                  this.alreadyConfirm = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 409:
                  this.alreadyConfirm = true;
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 404:
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = true;
                  this.alreadyConfirm = false;
                  break;
              }
            }),

            catchError((error) => {
              console.error('Erreur API : ', error);

              this.erreur = true;
              this.infoResponse =
                'Une erreur est survenue. Veuillez réessayer plus tard.';
              this.isSubmitting = true;
              setTimeout(() => {
                this.infoResponse = '';
                this.erreur = false;
                window.location.reload();
              }, 3500);

              // console.log('le formulaire : ', this.miniJpoForm);
              return of(null);
            })
          )
          .subscribe();
      }
    } else {
      // console.log('Le formulaire  invalid: ', this.miniJpoForm.value);

      this.filled = true;
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.jpoForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  private initForm() {
    this.jpoForm = this.formBuilder.group({
      prenom: this.prenomCtrl,
      nom: this.nomCtrl,
      email: this.emailCtrl,
      professionnalSituation: this.professionnalSituationCtrl,
      lieu: this.lieuDeProvenanceCtrl,
      indicatif: this.indicatifCtrl,
      telephone: this.waveNumberCtrl,
      gender: this.genderCtrl,
      lieuDeParticipation: this.lieuDeParticipationCtrl,
    });
  }
  private initControls() {
    this.professionnalSituationCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.lieuDeProvenanceCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.waveNumberCtrl = this.formBuilder.control('', Validators.required);
    this.genderCtrl = this.formBuilder.control('', Validators.required);
    this.prenomCtrl = this.formBuilder.control('', Validators.required);
    this.nomCtrl = this.formBuilder.control('', Validators.required);
    this.indicatifCtrl = this.formBuilder.control('+221', Validators.required);
    this.lieuDeParticipationCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.indicatifCtrl.disable();

    this.emailCtrl = this.formBuilder.control('', [
      Validators.email,
      Validators.required,
    ]);
  }

  private getCurrentJpo() {
    this.service
      .getCurrentJpo('')
      .pipe(
        tap((response: CustomResponse) => {
          if (response.status == 200) {
            // console.log('Je suis le JPO : ', response);
            this.activity = response.object as ActivityResponse;
            // console.log('activity : ', this.activity);
            this.session = true;
            this.spinnerService.hideSpinner();
            this.isLoading = false;
            this.noSession = false;
            this.activityId = this.activity.id;
          } else if (response.status == 404) {
            this.session = false;
            this.noSession = true;
            this.spinnerService.hideSpinner();
            this.isLoading = false;
          }
        })
      )
      .subscribe();
  }
}
